import { render, staticRenderFns } from "./pieModalChart.vue?vue&type=template&id=50b95885&scoped=true&"
import script from "./pieModalChart.vue?vue&type=script&lang=js&"
export * from "./pieModalChart.vue?vue&type=script&lang=js&"
import style0 from "./pieModalChart.vue?vue&type=style&index=0&id=50b95885&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b95885",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b95885')) {
      api.createRecord('50b95885', component.options)
    } else {
      api.reload('50b95885', component.options)
    }
    module.hot.accept("./pieModalChart.vue?vue&type=template&id=50b95885&scoped=true&", function () {
      api.rerender('50b95885', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/card/tenders/pieModalChart.vue"
export default component.exports